import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { titleCase } from 'title-case';
import BlueCheck from '../../../../../assets/icons/forms/checkedblue.svg';
import {
  selectBackgroundColor,
  selectButtonColor,
  selectButtonTextColor,
  setBackgroundColor,
  setBackgroundImageName,
  setBackgroundImageUrl,
  setButtonColor,
  setButtonTextColor,
} from '../../../../../store/reducers/forms';
import settingsStyles from '../ModalSettings/ModalSettings.module.scss';
import styles from './colorScheme.module.scss';
import { colorConfigurations } from './config';

const ColorScheme = () => {
  const dispatch = useDispatch();
  const [selectedConfig, setSelectedConfig] = useState(colorConfigurations[0]);
  const selectedButtonColor = useSelector(selectButtonColor);
  const selectedButtonTextColor = useSelector(selectButtonTextColor);
  const selectedBackgroundColor = useSelector(selectBackgroundColor);

  useEffect(() => {
    const configFromList = colorConfigurations.find(
      (config) =>
        config.buttonColour.toLowerCase() ===
          selectedButtonColor.toLowerCase() &&
        config.buttonTextColour.toLowerCase() ===
          selectedButtonTextColor.toLowerCase() &&
        config.backgroundColour.toLowerCase() ===
          selectedBackgroundColor.toLowerCase()
    );

    if (configFromList) {
      setSelectedConfig(configFromList);
    } else {
      setSelectedConfig(null);
    }
  }, [selectedButtonColor, selectedButtonTextColor, selectedBackgroundColor]);

  const handleColorClick = (config) => {
    if (!selectedConfig || selectedConfig.color !== config.color) {
      setSelectedConfig(config);
      dispatch(setButtonColor(config.buttonColour));
      dispatch(setButtonTextColor(config.buttonTextColour));
      dispatch(setBackgroundColor(config.backgroundColour));
      dispatch(setBackgroundImageName(''));
      dispatch(setBackgroundImageUrl(''));
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={settingsStyles.title}>{titleCase('Color Scheme')}</div>
      <div className={styles.colors_list}>
        {colorConfigurations.map((config) => (
          <div
            key={config.color}
            role="button"
            tabIndex={0}
            onClick={() => handleColorClick(config)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                handleColorClick(config);
              }
            }}
            className={`${styles.color_box} 
          ${selectedConfig?.color === config.color ? styles.selected : ''}`}
            style={{ backgroundColor: config.color }}
            aria-label={`Select color ${config.color}`}
          >
            {selectedConfig?.color === config.color && (
              <BlueCheck className={styles.blueCheckedIcon} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorScheme;
